import { render } from "./AddedGroup.vue?vue&type=template&id=5957e007"
import script from "./AddedGroup.vue?vue&type=script&lang=js"
export * from "./AddedGroup.vue?vue&type=script&lang=js"

import "./AddedGroup.vue?vue&type=style&index=0&id=5957e007&lang=scss"
script.render = render

export default script